import { cn } from 'utils/cn';

import styles from './styles.module.css';

interface TagProps extends React.ComponentProps<'div'> {
	children: React.ReactNode;
}

function Tag(props: TagProps) {
	return (
		<div {...props} className={cn(styles.container, props.className)}>
			{props.children}
		</div>
	);
}

export default Tag;
